import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { EntityType } from '@frontend/common';

export interface IGroup {
    num_members: number | null;
    num_entities: number | null;
    name: string;
    name_nl_be: string | null;
    name_en_us: string | null;
    name_fr_fr: string | null;
    name_de_de: string | null;
    node_type: NodeType;
    auto_generated: boolean;
    update_timestamp: string;
    id: string;
    account_id: string;
    entity_type: EntityType;
    creation_timestamp: string;
}

export interface CreateGroup {
    name?: string;
    name_nl_be?: string | null;
    name_en_us?: string | null;
    name_fr_fr?: string | null;
    name_de_de?: string | null;
    node_type?: NodeType;
}

export interface UpdateGroup {
    name?: string | null;
    node_type?: NodeType;
}

enum QueryParams {
    ID = 'id',
    NAME = 'name',
    ACCOUNT_ID = 'account_id',
    NODE_TYPE = 'node_type'
}
export type GroupQueryParams = DefaultQueryParams | QueryParams;
export type GroupListResponse = PaginatedResponse<IGroup>;

export enum NodeType {
    BRANCH = 'branch',
    LEAF = 'leaf',
    ROOT = 'root'
}

export const NodeTypeLabels = new Map([
    [NodeType.ROOT, 'Main category'],
    [NodeType.LEAF, 'Leaf category'],
    [NodeType.BRANCH, 'Subcategory']
]);
